import { render, staticRenderFns } from "./TableFallDetectionAnalytics.vue?vue&type=template&id=c988fc6e"
import script from "./TableFallDetectionAnalytics.vue?vue&type=script&lang=js"
export * from "./TableFallDetectionAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TableFallDetectionAnalytics.vue?vue&type=style&index=0&id=c988fc6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports